<div class="bill-overview">
  @switch (phase()) {
    @case ('overview') {
      <app-parent-context-banner></app-parent-context-banner>

      <!-- Stats bar -->
      <div class="stats-bar">
        <div class="stat-item">
          <span class="stat-value">{{ totalBills }}</span>
          <span class="stat-label">{{ totalBills === 1 ? 'Bill' : 'Bills' }}</span>
        </div>
        @if (!usageUnitsMixed) {
          <div class="stat-divider"></div>
          <div class="stat-item">
            <span class="stat-value">{{ totalUsage | number:'1.0-0' }}</span>
            <span class="stat-label">{{ usageUnitLabel }}</span>
          </div>
        }
        <div class="stat-divider"></div>
        <div class="stat-item highlight">
          <span class="stat-value">{{ totalAmount | currency:'USD':'symbol':'1.2-2' }}</span>
          <span class="stat-label">Total Amount</span>
        </div>
        @if (warningCount > 0) {
          <div class="stat-divider"></div>
          <div class="stat-item warning">
            <span class="stat-value"><i class="material-symbols-rounded">warning</i>{{ warningCount }}</span>
            <span class="stat-label">{{ warningCount === 1 ? 'Warning' : 'Warnings' }}</span>
          </div>
        }
      </div>

      <!-- Warning banner -->
      @if (warningCount > 0) {
        <div class="warning-banner">
          <i class="material-symbols-rounded">warning</i>
          <span>{{ warningCount }} bill{{ warningCount !== 1 ? 's have' : ' has' }} potential issues. Click a row to review and fix.</span>
        </div>
      }

      <!-- Bill table -->
      <div class="overview-table">
        <div class="overview-table-header">
          <span class="col-period">Billing Period</span>
          <span class="col-meter">Meter</span>
          <span class="col-provider">Provider</span>
          <span class="col-usage">Usage</span>
          <span class="col-amount">Amount</span>
          <span class="col-status">Status</span>
        </div>
        @for (row of billRows; track row.billGroupId) {
          <div class="overview-table-row"
               [class.has-warning]="row.warnings.length > 0"
               [class.skipped]="row.outcome?.tone === 'skip'"
               (click)="openBillDetail(row)">
            <span class="col-period">
              @if (row.isDual) {
                <span class="pair-dot" title="Paired bills, imported as one record">
                  <i class="material-symbols-rounded">link</i>
                </span>
              }
              {{ row.billPeriod }}
            </span>
            <span class="col-meter" [title]="row.saAddress">{{ row.meterUan }}</span>
            <span class="col-provider">{{ row.provider }}</span>
            <span class="col-usage">{{ row.usage | number:'1.0-0' }} {{ row.usageUnit }}</span>
            <span class="col-amount">{{ row.amount | currency:'USD':'symbol':'1.2-2' }}</span>
            <span class="col-status">
              @if (row.outcome) {
                <span class="outcome-badge" [class]="'outcome-badge ' + row.outcome.tone" [title]="row.outcome.title">
                  <i class="material-symbols-rounded" aria-hidden="true">{{ row.outcome.icon }}</i>
                  {{ row.outcome.label }}
                </span>
              }
              @if (row.warnings.length > 0) {
                <button class="warning-badge-btn" (click)="toggleWarnings(row.billGroupId); $event.stopPropagation()" title="View warnings">
                  <i class="material-symbols-rounded">warning</i>
                  {{ row.warnings.length }}
                </button>
              } @else if (!row.outcome) {
                <span class="ok-badge">
                  <i class="material-symbols-rounded">check_circle</i>
                </span>
              }
            </span>
          </div>
          @if (expandedWarnings[row.billGroupId] && row.warnings.length > 0) {
            <div class="warning-details">
              @for (warning of row.warnings; track warning) {
                <div class="warning-item">
                  <i class="material-symbols-rounded">info</i>
                  <span>{{ warning }}</span>
                </div>
              }
            </div>
          }
        }
      </div>

      <!-- Energy plan notice -->
      @if (hasEnergyPlanBills()) {
        <div class="ep-notice">
          <i class="material-symbols-rounded">electric_bolt</i>
          <span>Some bills have suppliers that need energy plan decisions. You'll set those up next.</span>
        </div>
      }

      <!-- Validation Banner -->
      @if (hasValidationBlockers) {
        <div class="validation-banner">
          <div class="validation-banner-title">
            <i class="material-symbols-rounded">block</i>
            Fix these before continuing
          </div>
          @for (group of validationGroups; track group.entityLabel) {
            <div class="validation-banner-group">
              <div class="group-label">{{ group.entityLabel }}</div>
              <ul>
                @for (field of group.fields; track field) {
                  <li>{{ field }}</li>
                }
              </ul>
            </div>
          }
        </div>
      }

      <!-- Actions -->
      <div class="actions-bar">
        <button class="btn-secondary" (click)="goBack()">
          <i class="material-symbols-rounded">arrow_back</i>
          Back
        </button>
        <button class="btn-primary" (click)="continue()">
          @if (hasEnergyPlanBills()) {
            Continue to Energy Plans
          } @else {
            Continue to Import
          }
          <i class="material-symbols-rounded">arrow_forward</i>
        </button>
      </div>
    }

    @case ('detail') {
      <div class="detail-back-bar">
        <button class="back-to-overview-btn" (click)="reviewStep.onBackToOverview()">
          <i class="material-symbols-rounded">arrow_back</i>
          Back
        </button>
      </div>
      <app-bill-ai-flow-bill-review-step
        #reviewStep
        [showBackToOverview]="true"
        (backToOverview)="backToOverview()">
      </app-bill-ai-flow-bill-review-step>
    }

    @case ('energy-plans') {
      <app-bill-ai-flow-energy-plan-prompt (back)="backToOverview()"></app-bill-ai-flow-energy-plan-prompt>
    }
  }
</div>
